import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const editGroup = async ({
	id,
	payload
}: {
	id: number;
	payload: Record<string, unknown>;
}) => {
	const response = await cmsClient.patch<IGroup>(
		`/homepage/admin/socialprofilegroup/${id}/`,
		payload
	);

	return response.data;
};

const useEditGroup = () => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		toast.success(<CustomToast type="Success" message="Group updated" />, {
			hideProgressBar: true
		});
	};

	const onSettled = () => {
		queryClient.invalidateQueries(["admin-groups"]);
	};

	const onError = (error: unknown) => {
		const detail = (error as { response?: { data?: Record<string, unknown> } })
			?.response?.data;
		const message =
			(detail as { detail?: string })?.detail ??
			(detail ? Object.values(detail).flat().join(" ") : undefined) ??
			"Something went wrong, try again";

		toast.error(<CustomToast type="Error" message={message} />, {
			hideProgressBar: true
		});
	};

	const mutation = useMutation(editGroup, {
		onError,
		onSuccess,
		onSettled
	});

	return mutation;
};

export default useEditGroup;
